


var swiper = new Swiper(".shop-by-categoryslider", {
        slidesPerView: 6.5,
        spaceBetween: 35,
        loop: false,
         pagination: {
          el: ".swiper-pagination",
           clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
       //  autoplay: {
       //      delay: 3000,
       //     disableOnInteraction: false, 
       // },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 5,
                autoplay: true
            },
            440: {
                slidesPerView: 3,
                spaceBetween: 5,
                autoplay: true
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 25
            },
            1199: {
                slidesPerView: 5,
                spaceBetween: 25
            },
            1280: {
                slidesPerView: 6,
                spaceBetween: 25
            }
        }
    });


var swiper = new Swiper(".happy-client", {
        slidesPerView: 1,
        spaceBetween: 25,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
           clickable: true,
        },
   navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        // navigation: {
        //     nextEl: ".swiper-button-next",
        //     prevEl: ".swiper-button-prev"
        // },
       //  autoplay: {
       //      delay: 2000,
       //     disableOnInteraction: true, 
       // },
    
    });
/*
if ($('.product-recently-viewed__content').find('.product-recently-viewed-card').length === 0) {
  // Hide the entire recently viewed section
  $('.recently-viewed--section').hide();
}*/
document.addEventListener('DOMContentLoaded', function () {
  const content = document.querySelector('.product-recently-viewed__content');
  const cards = content ? content.querySelectorAll('.product-recently-viewed-card') : [];

  if (cards.length === 0) {
    const section = document.querySelector('.recently-viewed--section');
    if (section) {
      section.style.display = 'none';
    }
  }
});


